import { Outlet, useLocation } from 'react-router-dom'

import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useAttendanceContextlessPolicies } from 'modules/attendance/hooks/useAttendanceContextlessPolicies'
import CollectionsBootstrap from 'modules/attendance/lib/ClockinCollectionsBootstrap'
import {
  AttendancePoliciesProvider,
  useAttendancePolicies,
} from 'modules/attendance/lib/attendancePolicies'
import { hasRegularAccessOrNotEmployee } from 'modules/employees/lib/utils'

const Container = () => {
  const { employee } = useCurrentSession()
  const { loading, data } = useAttendancePolicies()
  const employeeCanSeeAttendance = !!data?.employee?._policies?.seeAttendance?.can
  const { companyReadAttendance: adminCanSeeAttendance, loading: loadingAdminPolicy } =
    useAttendanceContextlessPolicies()
  const { pathname } = useLocation()
  const isTimeTrackingPage = pathname.includes('time-tracking')

  if (isTimeTrackingPage && !loadingAdminPolicy && !adminCanSeeAttendance) {
    return <NotFound />
  }

  if (
    (!isTimeTrackingPage && !loading && !employeeCanSeeAttendance) ||
    !hasRegularAccessOrNotEmployee(employee)
  ) {
    return <NotFound />
  }

  return <Outlet />
}

const EmployeeRootPage = () => {
  const { employee } = useCurrentSession()

  return (
    <CollectionsBootstrap>
      <AttendancePoliciesProvider employeeId={employee?.id ?? '0'}>
        <Container />
      </AttendancePoliciesProvider>
    </CollectionsBootstrap>
  )
}

export default EmployeeRootPage
